<template>   
  <div>
    <v-card flat>      
        <div>
          <v-row no-gutters fill-height>
            <v-expansion-panels
              v-model="panel"
              :disabled="disabled"
              multiple 
              accordion     
            >
              <v-expansion-panel>
                <v-expansion-panel-header>Select Condition</v-expansion-panel-header>
                <v-expansion-panel-content dense                  
                >               
                   <!-- =============Start Search Condition============= -->
                    <v-row dense >
                        <!-- Ship No -->
                        <v-col                            
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="Ship No"
                              v-model="shipNo" 
                              :items="shipNoList" 
                              return-object 
                              item-value="shipNo" 
                              outlined
                              dense
                            >
                            </v-select>
                        </v-col>
                        <!--Stage Code -->
                        <v-col                            
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="Stage"
                              v-model="stgName" 
                              :items="stgNameList" 
                              return-object 
                              item-value="stgName" 
                              outlined
                              dense
                            >
                            </v-select>
                        </v-col>
                        <!-- Block -->
                        <v-col 
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4">
														<v-text-field
                                label="Block"
                                dense 
                                outlined 
                                hide-details="auto"
                                clearable 
                                maxLength="4"
                                v-model="block"
                                @keyup="uppercase"
														    @keyup.enter="btnRetrieve()"
                                                        />
													</v-col>
                        <!-- Retrieve button -->
                        <!-- <v-col
                          cols="6"
                          sm="6"
                          md="4"
                        >
                          <v-btn 
                          
                            height = "30px"
                            class="mt-2 "
                            block
                            dense
                            color="success"
                            @click="btnRetrieve"
                          >
                            <v-icon left>
                              {{ icons.mdiMapSearch }}
                            </v-icon>
                            Retrieve
                          </v-btn>
                        </v-col> -->
                    </v-row>
                    <!-- ==========End Search Condition================= -->                  
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </div>
         <!-- Change theme -->
         <v-fab-transition>
          <v-btn
            v-show="!isMobileDevice" 
            @click="btnRetrieve"
            absolute
            top
            right
            fab
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-fab-transition>
    </v-card> 
    
    <v-card class="mt-2">  
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>  
          <div class="ml-2">Count List: {{ gridMainList.length }}</div>
          <v-data-table
            :mobile-breakpoint="800"
            :items-per-page="listSize"
            :headers="headers"
            :items="gridMainList"
            :search="search"
            :dense="true"
            :sort-by="[]"
            :sort-desc="[false]"
            :dark="dark"
            fixed-header
            :height="isMobileDevice ? undefined : 600"
            class="mobile-clean-table"
            style="max-width: 100%; overflow-x: auto;"
          >
            <template v-slot:item="{ item, isMobile }">
    
              <mobile-card-item
                  v-if="isMobile"
                  :item="item"
                  :header-value="item.rno"
                  :active="selectedRowIndex === item.rno"
                  :fields="mobileFields"            
                  >
                <template v-slot:actions>
                  <div class="d-flex justify-end mt-1">
                    <v-chip
                      v-if="item.fileCnt > 0"
                      outlined
                      small
                      :color="getColor(item.rno)"
                      :dark="dark"
                      @click="openDialog(item, 'B')"
                    >
                      Before: {{ item.fileCnt}} file
                    </v-chip>
                    
                    <v-chip
                      v-if="item.fileCntAft > 0"
                      outlined
                      small
                      :color="getColor(item.rno)"
                      :dark="dark"
                      @click="openDialog(item, 'A')"
                    >
                      After: {{ item.fileCntAft}} file
                    </v-chip>
                  </div>
                </template>

                
              </mobile-card-item>

              <tr v-else class="custom-pc-row">
                <td class="v-data-table__divider text-center">{{ item.rno }}</td>
                <td class="v-data-table__divider text-center">{{ item.shipNo }}</td>
                <td class="v-data-table__divider text-center">{{ item.block }}</td>
                <td class="v-data-table__divider text-center">{{ item.stgCd }}</td> 
                <td class="v-data-table__divider text-center">
                  <div class="d-flex align-center">
                    <v-chip
                      v-if="item.fileCnt > 0"
                      outlined
                      small
                      :color="getColor(item.rno)"
                      :dark="dark"
                      @click="openDialog(item, 'B')"
                    >
                      Before: {{ item.fileCnt}} file
                    </v-chip>
                    
                    <v-chip
                      v-if="item.fileCntAft > 0"
                      outlined
                      small
                      :color="getColor(item.rno)"
                      :dark="dark"
                      @click="openDialog(item, 'A')"
                    >
                      After: {{ item.fileCntAft}} file
                    </v-chip>
                  </div>
                </td>                
              </tr>
            </template>
              
          </v-data-table>
          <!--Start Open file detail -->
          <v-dialog 
            v-model="dialog"                    
            scrollable
            persistent
            transition="dialog-bottom-transition"
            width="500"                 
            >
            <v-card v-if="selectedItem" class="rounded-lg">
              <v-card-title class="headline grey lighten-2 py-3 px-4">
                <span class="text-h6 font-weight-bold">{{ formTitle }} (No. {{ selectedItem.rno }})</span>                   
                <v-spacer></v-spacer>
                <v-btn
                  :dark="dark"
                  icon
                  @click="close"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pa-0 bg-white" > 
                  <v-data-table
                      :mobile-breakpoint="600"
                      :headers="dialogHeaders"
                      :items="dialogItemList"
                      hide-default-footer
                      dense
                      disable-pagination
                      fixed-header
                      :height="isMobileDevice ? '60vh' : '600px'"
                      class="mobile-clean-table"
                      style="max-width: 100%; overflow-x: auto;"
                    >
                      <template v-slot:item="{ item, isMobile }">
    
                        <mobile-card-item
                            v-if="isMobile"
                            :item="item"
                            :header-value="item.rno"
                            :fields="mobileFiles"            
                            >
                              <template v-slot:openFile> 
                                <div class="d-flex align-center justify-end">
                                  <v-btn 
                                    small 
                                    text 
                                    color="error" 
                                    @click="handleOpenPdf(item)"
                                  >
                                    <v-icon left small>mdi-file-pdf-box</v-icon>
                                    View file
                                  </v-btn>
                                </div>
                              </template>                     
                          
                        </mobile-card-item>

                        <tr v-else class="custom-pc-row">                         
                          <td class="v-data-table__divider text-center">{{ item.rno }}</td>
                          <td class="v-data-table__divider text-center">{{ item.fileNm }}</td>
                          <td class="text-center v-data-table__divider">
                            <v-chip 
                              :color="getColor(item.rno)" 
                              dark
                              @click="handleOpenPdf(item)"
                            >
                              View file</v-chip>
                          </td>
                          
                        </tr>
                      </template>
                  </v-data-table> 
              </v-card-text>   
              <v-divider></v-divider>
              <v-card-actions class="pa-3">
                <v-spacer></v-spacer>
                <v-btn color="primary" text font-weight-bold @click="dialog = false">
                  Close
                </v-btn>
              </v-card-actions>                 
            </v-card>                
          </v-dialog>
          <!--End Open file detail -->
    </v-card>
    <!-- Scroll To Top -->
    <v-btn
      v-scroll="onScroll"
      v-show="fab && isMobileDevice"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
      style="z-index: 1000;"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
  </div>  
</template>

<script>
import  {
        mdiAccount,
        mdiPencil,
        mdiShareVariant,
        mdiDelete,
        mdiSelectSearch,
        mdiMapSearch 

      } from '@mdi/js'

import  { getShipList, 
          getStageList,
      } from '@/api/view/tqm/80/v80comm.js'

import  {
        v80b1030List,
        v80b1030FileList,
      } from '@/api/view/tqm/80/v80b1030.js'

import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page addition
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // Add base when using data grid
import { ftpDownload, ftpDownloadViewer } from '@/api/view/tqm/common/common.js'
import { DxScrollView } from "devextreme-vue/scroll-view";
import { mobileTableMixin } from '@/mixins/mobileTableMixin.js' // Import mixin mới
import EventBus from '@/components/event-bus';

export default {
name: "v80b1030",
mixins: [baseview, BaseDataGrid, mobileTableMixin],
data: () => ({
  fab: false,
  dark: false,
  isMobileDevice: false, // Biến mới
  icons: {
    mdiAccount,
    mdiPencil,
    mdiShareVariant,
    mdiDelete,
    mdiSelectSearch,
    mdiMapSearch

  },
  customText: 'Control file',
  shipNoList: [],
  shipNo: '',
  stgCd: '',
  stgName: '',
  stgNameList: [],
  block: '',
 
  panel: [0],
  disabled: false,
  hover: true,

  // data
  gridMainList: [],
  listSize: 0,
  listFileSize: 0,
  
  mobile: true,
  search: '',
  headers: [
              {
                text: 'No',
                align: 'center',
                value: 'rno',
                divider: true,
                sortable: false,
                width: '20px',
              },
              { text: 'Ship No', sortable: false, align: 'center',value: 'shipNo', width: '30px'},
              { text: 'Block', sortable: false, align: 'center',value: 'block', width: '30px'},
              { text: 'Stage Name', sortable: false,  align: 'center',value: 'stgCd', width: '80px'},
              { text: 'Control file', sortable: false,  align: 'center', value: 'actions', width: '300px'},
              { text: '', sortable: false,  align: 'center', value: '', },
            ],

  dialog: false,
  openFileIndex: -1,
      openFileItem: {
        shipNo: '',
        block: '',
        stgCd: '',
      },
  dialogHeaders: [
                    {
                      text: 'No',
                      align: 'center',
                      value: 'rno',
                      sortable: false, 
                    },
                    { text: 'File Name', sortable: false, align: 'center', value: 'fileNm', },
                    { text: 'Control file', sortable: false, align: 'center', value: 'openFile', },

  ],
  dialogItemList: [],
  dialogDiv:'',
  dialogRno:'',
  selectedRowIndex: null, // Lưu index của dòng đang được chọn 
  // Chỉ cần khai báo list này là giao diện tự sinh ra
  mobileFiles: [
    // { label: 'No', key: 'rno' },
    { label: 'File Name', key: 'fileNm' },
    { label: 'Control file', key: 'openFile' },

  ],   

  mobileFields: [
    // { label: 'No', key: 'rno' },
    { label: 'Ship No', key: 'shipNo' },
    { label: 'Block', key: 'block' },
    { label: 'Stage Name', key: 'stgCd' },
    { label: 'Control file', key: 'actions' }, 

  ], 

}),
components: {
  DxDateBox,
  DxScrollView,
  // AppButton,
},

computed: {
  formTitle () {
        return this.openFileIndex === -1 ? ' Detail before files' : ' Detail after files'
      },
  },

  watch: {
    /*  options: {
    handler () {
      this.btnRetrieve()
    },
    deep: true,
  }, */
  },
  created() {
    EventBus.$on(this.$options.name + "_search", () => { 
      this.btnRetrieve();
    });
  },
  mounted() {
    this.init()
    //Apply for Fab
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);

    this.loadColumnWidths(); // Khôi phục ngay khi load trang
    
    // Lắng nghe sự kiện thả chuột để lưu lại kích thước mới
    this.$el.querySelector('.v-data-table').addEventListener('mouseup', () => {
      // Đợi một chút để trình duyệt cập nhật xong style.width
      setTimeout(() => {
        this.saveColumnWidths();
      }, 100);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
    EventBus.$off(this.$options.name + "_search");
  },
  methods: {
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    },

    getHeaders(){
        return [
              {
                text: 'No',
                align: 'center',
                value: 'rno',
                divider: true,
            
              },
              { text: 'Ship No', align: 'center',value: 'shipNo', },
              { text: 'Block', align: 'center',value: 'block', },
              { text: 'Stage', align: 'center',value: 'stgCd', },
              { text: this.customText, align: 'center', sortable: false },
            ];
    },
    
    btnRetrieve() {
     
      if (this.shipNo !== 'All') {
        this.gridMainList = []
        this.getMainList()
      } else {
        this.vToastify(this.$t('Sorry!, Select a Ship!'), 'warn')
        return
      }
    },

    init() {   

      this.getList()

    },    
    //getList
    async getList() {
      try {
          this.openLoading('searching')
          let params = {
            shipNo: '',
          }         

          // getShipList
          await getShipList(params).then(res => {
                  this.shipNoList.push('All')
                  res.list.forEach(e => {
                    this.shipNoList.push(e.shipNo)
                  });
                  this.shipNo = this.shipNoList[0]
                })

          await getStageList(params).then(res => {
                  // this.stgNameList.push('All')
                  res.list.forEach(e => {
                    this.stgNameList.push(e.stgCd + ' : ' + e.stgNm)
                  });
                  this.stgName = this.stgNameList[0]
                })

         

          } finally {
              
              this.endLoading()
          }

    },
       

  async getMainList() {
        try {
            this.openLoading('searching')
            
            let stgName = this.stgName
                stgName = stgName.split(' : ')  
                this.stgCd = stgName[0]  
                          
            let params = {                
                shipNo: this.shipNo === 'All' ? '' : this.shipNo,
                stgCd: this.stgCd === 'All' ? '' : this.stgCd,
                block: this.block,

            }
            
            // console.log('######paramsgetMainList===>', params)

            await v80b1030List(params).then(res => {
              let list = []
              // console.log('######v80b1030List===>', res)
                res.list.forEach(e => {
                  list.push({
                    ...e,
                    stgCd: e.stgCd+' : '+ e.stgNm,

                  })
                  
                });

                this.gridMainList = list
                this.listSize = this.gridMainList.length;

                if (this.listSize > 0 && this.isMobileDevice) {
                  this.panel = [];
                }
                // console.log('######listSize===>', this.listSize)
            })
        } catch (error) {
          console.error("Lỗi getMainList:", error);        
        } finally {
            this.endLoading()
        }
  },

  // Hàm lưu độ rộng vào localStorage
  saveColumnWidths() {
    const widths = {};
    const ths = this.$el.querySelectorAll('.v-data-table th');
    
    ths.forEach((th, index) => {
      // Lưu theo index hoặc value của header để không bị lẫn
      widths[index] = th.style.width;
    });
    
    localStorage.setItem(`table_width_${this.$options.name}`, JSON.stringify(widths));
  },

  // Hàm khôi phục độ rộng khi vào lại trang
  loadColumnWidths() {
    const savedWidths = localStorage.getItem(`table_width_${this.$options.name}`);
    if (savedWidths) {
      const widths = JSON.parse(savedWidths);
      this.$nextTick(() => {
        const ths = this.$el.querySelectorAll('.v-data-table th');
        ths.forEach((th, index) => {
          if (widths[index]) {
            th.style.width = widths[index];
          }
        });
      });
    }
  },

  getColor (value) {
      if (value > 40) return 'red'
      else if (value > 20) return 'orange'
      else return 'green'
  },  

  openDialog (item, div) {

        // this.dialogDiv = div
        // console.log('#####DialogDivision====>', div)

        if(div==='B'){
          this.openFileIndex = -1          
        }else{
          this.openFileIndex = 1
        }
        this.selOpenFile(item, div)        
        
  },

  selOpenFile(item, div){
    let cntFile;
    let files;
    this.selectedItem = Object.assign({}, item); 
    if (div==='B'){
      cntFile = item.fileCnt
      files = {
        imgNo: item.imgNo,
        fileNm: item.fileNm,
        div: item.div
      }
    }else{
      cntFile = item.fileCntAft
      files = {
        imgNo: item.imgNoAft,
        fileNm: item.fileNmAft,
        div: item.divAft
      }
    }

    if (cntFile == 1){
      // this.fileOpen(files)
      this.handleOpenPdf(files)
    }else if (cntFile > 1){
      this.initialize(item, div)
      this.dialogRno = item.rno
      this.dialog = true
    }else{
      this.vToastify(this.$t('Sorry!, No attach file!'), 'warn')
      this.dialog = false
    }

  },
  
  close () {
        this.dialog = false
        this.$nextTick(() => {
          // this.openFileItem = Object.assign({}, this.defaultItem)
          this.openFileIndex = -1
        })
  },    

  async initialize (obj, div) {
      try {
            this.openLoading('searching') 

            let params = {                
                shipNo: obj.shipNo,
                stgCd: obj.stgCd.split(' : ')[0],
                block: obj.block,
                div: div

            }
            
            // console.log('######paramsDialog===>', params)

            await v80b1030FileList(params).then(res => {
              let list = []
              // console.log('######v80b1030FileList===>', res)
                res.list.forEach(e => {

                    list.push({
                      rno: e.rno,
                      imgNo: e.imgNo,
                      fileNm: e.fileNm,
                      div: e.div
                    })
                  
                });

                this.dialogItemList = list
                this.listFileSize = list.length
                // console.log('######listFileSize===>', this.listFileSize)
            })

        } finally {
            this.endLoading()
        }
    
  },  
  
  fileOpen(e){
    // console.log('######fileOpen===>', e)
      let dirPath = '';
      if(e.div ==='B'){
        dirPath = 'attachfile/PRODUCTION/DIMENSION/RESULT/';
      }else{
        dirPath = 'attachfile/PRODUCTION/DIMENSION/RESULT_AFT/';
      }

      let fileType = e.fileNm.substring(e.fileNm.lastIndexOf('.') + 1);
      let filePath = dirPath + e.imgNo + '.' + fileType;
      // console.log('######fileType===>', fileType)
      // console.log('######fileNo===>', e.imgNo)
      this.openLoading('searching')
      ftpDownload(filePath, e.imgNo)
      .finally(() => {
        this.endLoading()
      })
  },
  // 2. Xử lý mở PDF
  async handleOpenPdf(e) {
    // Thêm dòng kiểm tra này ở đầu hàm
    if (!e || !e.fileNm) {
      console.error("Invalid file data:", e);
      return;
    }
    let dirPath = '';
    try {
      this.openLoading('Opening PDF...');      
      // Xác định đường dẫn file dựa trên type (wps hoặc pqr)
      
      if(e.div ==='B'){
        dirPath = 'attachfile/PRODUCTION/DIMENSION/RESULT/';
      }else{
        dirPath = 'attachfile/PRODUCTION/DIMENSION/RESULT_AFT/';
      }

      const fileType = e.fileNm.substring(e.fileNm.lastIndexOf('.') + 1);
      const filePath = dirPath + e.imgNo + '.' + fileType;

      // const filePath = type === 'wps' ? item.wpsnofile : item.pqrnofile;
      if (!filePath) return;

      // Tải file từ FTP
      const res = await ftpDownloadViewer(filePath, fileType);
      
      if (res && res.body) {
        // TẠO BLOB VÀ MỞ TRONG TAB MỚI (Thay vì gán vào item làm nặng dữ liệu)
        const byteCharacters = atob(res.body);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const file = new Blob([byteArray], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        
        window.open(fileURL, '_blank');
      }
    } catch (error) {
      console.error("Mở PDF thất bại:", error);
    } finally {
      this.endLoading();
    }
  },
  uppercase(){      
        this.block = this.block.toUpperCase()
  },

},

};
</script>
<style>
/* Import file CSS dùng chung cho toàn bộ Mobile Card */
/* Sử dụng dấu ~ trước @ để Webpack nhận diện đúng alias */
@import "~@/assets/css/mobile-table.css";

/* Các CSS tùy chỉnh khác cho menu này */
.border-bottom {
  border-bottom: 1px dashed #eee;
}
.v-card__text {
  max-height: 70vh; /* Giới hạn chiều cao popup trên mobile */
}

.custom-pc-row td .v-image__image {
  background-size: contain !important; /* Đảm bảo ảnh vẽ kỹ thuật luôn thấy hết chi tiết */
}

/* Trong mobile-table.css hoặc style của v80w1010.vue */
.cursor-pointer {
  cursor: zoom-in !important; /* Đổi icon chuột thành hình kính lúp */
  transition: opacity 0.3s;
}

.cursor-pointer:hover {
  opacity: 0.8; /* Hiệu ứng mờ nhẹ khi di chuột qua */
}

/* Hiệu ứng cho icon kẹp giấy */
.pdf-icon-btn {
  transition: all 0.2s ease-in-out; /* Giúp hiệu ứng mượt mà hơn */
  cursor: pointer;
}

/* Khi di chuột vào trên PC */
.pdf-icon-btn:hover {
  transform: scale(2); /* Phóng to 30% */
  color: #d32f2f !important; /* Đổi sang màu đỏ đậm hơn (v-red-darken-2) */
  filter: drop-shadow(0px 2px 4px rgba(0,0,0,0.2)); /* Thêm bóng đổ nhẹ */
}

/* Hiệu ứng khi nhấn vào (Active) */
.pdf-icon-btn:active {
  transform: scale(1.1);
  opacity: 0.7;
}

/* Thu hẹp khoảng cách giữa checkbox và label trong Vuetify 2 */
.v-application--is-ltr .v-input--selection-controls__input {
  margin-right: 1px !important; 
}

/* Tùy chỉnh màu label cho đậm nét hơn trên mobile nếu cần */
.v-input--selection-controls .v-label {
  font-size: 13px !important;
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>
